import { Button } from "antd";
import { translate } from "utils";
import { UndoOutlined } from "@ant-design/icons";
import clsx from "clsx";

export function ResetBtn({
	onClick,
	className,
}: {
	onClick: () => void;
	className?: string;
}) {
	return (
		<Button
			icon={<UndoOutlined />}
			className={clsx( "flex items-center" ,className)}
			onClick={onClick}
			htmlType={"button"}
		>
			{translate("Reset")}
		</Button>
	);
}
